import AnchorCardV4 from '../../../common/component/AnchorCardV4';
import LabelBadgeV4 from '../../../common/component/LabelBadgeV4';
import {Page} from '../../../common/constant/page';
import {showAuthModal} from '../../../common/function';
import useLogin from '../../../common/hook/useLogin';
import useTypedSelector from '../../../common/hook/useTypedSelector';
import ContentLikeV4 from '../../../commonSub/component/ContentLikeV4';
import {getIsNotAllowedAdultContent} from '../../../commonSub/function';
import {IBigContent} from '../../../commonSub/type';
import {ITimeTableKeywordHandler, ITimeTableLikeHandler} from '../type';

interface IProps {
  index: number;
  content: IBigContent;
  className?: string;
  showLikeInfo?: boolean;
  onClick?: (content: IBigContent, index: number) => void;
  onClickLike?: ITimeTableLikeHandler;
  onClickKeyword?: ITimeTableKeywordHandler;
}

export default function TimeTableBigContentCardV4({
  index,
  content,
  className,
  showLikeInfo,
  onClick,
  onClickLike,
  onClickKeyword,
}: IProps) {
  const {id, sid, label, authors, isLike, descLine2, seoKeywords, isAdult} =
    content;
  const user = useTypedSelector(state => state.auth.user);
  const {isLoginChecking, isLogin} = useLogin();
  return (
    <AnchorCardV4
      blackMaskOpacity="50%"
      pageInfo={{
        page: Page.Content,
        id,
        sid,
      }}
      content={content}
      labelBadgeElement={label && <LabelBadgeV4 label={label} />}
      desc={authors}
      className={className}
      bottomElement={
        showLikeInfo && (
          <ContentLikeV4
            isLike={!!isLike}
            description={descLine2}
            keywords={seoKeywords}
            onClickLike={isContentLike => {
              if (!isLogin) {
                // 찜하기 눌렀을때 성인 작품인지 여부보다 로그인 여부 우선 체크
                // TODO: getIsNotAllowedAdultContent 로 한번에 처리할 수 있을지 확인해보자. (https://github.com/kakaoent/kakaowebtoon-web/pull/768)
                showAuthModal({isSaveReturnPage: true});
                return;
              } else if (
                isAdult &&
                getIsNotAllowedAdultContent({
                  isLoginChecking,
                  isLogin,
                  user,
                })
              ) {
                return;
              }
              onClickLike?.({
                contentId: content.id,
                index,
                isLike: isContentLike,
              });
            }}
            className="px-7"
            onClickKeyword={keyword =>
              onClickKeyword?.({content, keyword, index})
            }
          />
        )
      }
      onClick={() => onClick?.(content, index)}
    />
  );
}
